module.exports = __webpack_public_path__ + "static/media/boltOff_118.d292e5d7.png";